import { render, staticRenderFns } from "./TheNewFormView.vue?vue&type=template&id=333a36f1&scoped=true&"
import script from "./TheNewFormView.vue?vue&type=script&lang=js&"
export * from "./TheNewFormView.vue?vue&type=script&lang=js&"
import style0 from "./TheNewFormView.vue?vue&type=style&index=0&id=333a36f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a36f1",
  null
  
)

export default component.exports